import { call, put, takeEvery } from 'redux-saga/effects';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';
import * as types from './hourlyVolumeShareActionType';
import * as actions from './hourlyVolumeShareActions';
import * as services from './hourlyVolumeShareServices';
import { downloadBase64File } from "../../../../utils/fileDownloads";


//------------------Rad Hourly Volume Share - start------------------//
function* fetchRadHourlyVolumeShareUnReadDetailsSaga(action) {
    try {
        const response = yield call(services.getRadSiteUnReadRvuDetails, action.payload);
        if (response?.success) {
            yield put(actions.fetchRadHourlyVolumeShareUnReadDetailsSuccess(response.values));
        } else {
            yield put(actions.fetchRadHourlyVolumeShareUnReadDetailsFailure('No data found'));
        }
    } catch (error) {
        console.error('Provider Facility Unread RVU Details Fetch Error:', error);
        yield put(actions.fetchRadHourlyVolumeShareUnReadDetailsFailure('Failed to fetch Provider Facility Unread RVU Details'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Provider Facility Unread RVU Details' });
    }
}

function* fetchRadHourlyVolumeShareReadDetailsSaga(action) {
    try {
        const response = yield call(services.getRadSiteReadRvuDetails, action.payload);
        if (response?.success) {
            yield put(actions.fetchRadHourlyVolumeShareReadDetailsSuccess(response.values));
        } else {
            yield put(actions.fetchRadHourlyVolumeShareReadDetailsFailure('No data found'));
        }
    } catch (error) {
        console.error('Provider Facility Read RVU Details Fetch Error:', error);
        yield put(actions.fetchRadHourlyVolumeShareReadDetailsFailure('Failed to fetch Provider Facility Read RVU Details'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Provider Facility Read RVU Details' });
    }
}

// function* exportRadHourlyVolumeShareSaga(action) {
//     try {
//         const { exportAPIURL, payload, moduleName, fileName } = action.payload;
//         const response = yield call(services.exportRadHourlyVolumeShare, exportAPIURL, payload);
//         const base64Data = response?.values || response;
//         yield call(downloadBase64File, base64Data, moduleName, fileName);
//     } catch (error) {
//         console.error("Export error:", error);
//         yield put(actions.exportRadHourlyVolumeShareFailure("Export failed"));
//     }
// }

function* exportRadHourlyVolumeShareSaga(action) {
    try {
        const { exportAPIURL, payload, moduleName, fileName } = action.payload;

        const response = yield call(
            services.exportRadHourlyVolumeShare,
            exportAPIURL,
            payload
        );

        if (response?.success) {
            const base64Data = response?.values || response;
            
            if (base64Data) {
                yield call(downloadBase64File, base64Data, moduleName, fileName);
            }

            yield put(actions.exportRadHourlyVolumeShareSuccess());

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Export completed successfully.'
            });

        } else {
            yield put(
                actions.exportRadHourlyVolumeShareFailure(
                    response?.errorMessage || 'Failed to export report'
                )
            );

            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to export report.'
            });
        }

    } catch (error) {
        console.error("Export error:", error);

        yield put(
            actions.exportRadHourlyVolumeShareFailure(
                error?.message || "Export failed"
            )
        );

        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to export hourly volume share report.'
        });
    }
}


function* getDropdownRadSitesSaga() {
    try {
        const response = yield call(services.getDropdownRadSites);
        if (response?.success) {

            yield put(actions.getDropdownRadSitesSuccess(response.values));
        } else {
            yield put(actions.getDropdownRadSitesFailure('No data found'));
        }
    } catch (error) {
        console.error('Dropdown Provider Facilities Fetch Error:', error);
        yield put(actions.getDropdownRadSitesFailure('Failed to fetch Dropdown Provider Facilities'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Dropdown Provider Facilities' });
    }
}

function* getWorklistRpceIDSaga(action) {
    try {
        // Extract payload from action
        const { rpceIds } = action.payload;

        // Call API with rpceIds
        const response = yield call(services.getWorklistID, rpceIds);

        if (response?.success) {
            // Extract WorkListDropdownItems from response.values
            yield put(actions.getWorklistByRpceIdSuccess(response.values?.WorkListDropdownItems || []));
        } else {
            yield put(actions.getWorklistByRpceIdFailure('No data found'));
        }
    } catch (error) {
        console.error('Worklist Provider Facilities Fetch Error:', error);
        yield put(actions.getWorklistByRpceIdFailure('Failed to fetch Worklists'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Worklists' });
    }
}

function* getPracticeByWorklistIDSaga(action) {
    try {
        // Extract payload from action
        const { worklistIds } = action.payload;
        
        // Call API with worklistIds
        const response = yield call(services.GetPracticesByWorklistID, worklistIds);
        if (response?.success) {
            // Extract PracticeDropdownItems from response.values
            yield put(actions.getPraticesByWorklistIdSuccess(response.values?.Practices || []));
        } else {
            yield put(actions.getPraticesByWorklistIdFailure('No data found'));
        }
    } catch (error) {
        console.error('Practice Fetch Error:', error);
        yield put(actions.getPraticesByWorklistIdFailure('Failed to fetch Practices'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Practices' });
    }
}

function* getSubPracticeByPracticeIDSaga(action) {
    try {
        // Extract payload from action
        const { practiceIds } = action.payload;
        
        // Call API with practiceIds
        const response = yield call(services.GetSubPracticesByPracticeID, practiceIds);
        if (response?.success) {
            // Extract SubPracticeDropdownItems from response.values
            yield put(actions.getSubPraticesByPraticeIdSuccess(response.values?.dropdownItems || []));
        } else {
            yield put(actions.getSubPraticesByPraticeIdFailure('No data found'));
        }
    } catch (error) {
        console.error('SubPractice Fetch Error:', error);
        yield put(actions.getSubPraticesByPraticeIdFailure('Failed to fetch SubPractices'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load SubPractices' });
    }
}

function* getSiteBySubPraticeIDSaga(action) {
    try {
        // Extract payload from action
        const { subPracticeIds } = action.payload;
        
        // Call API with subPracticeIds
        const response = yield call(services.GetSiteBySubPracticeID, subPracticeIds);
        if (response?.success) {
            // Extract SiteDropdownItems from response.values
            yield put(actions.getSiteBySubPraticeIdSuccess(response.values?.dropdownItems || []));
        } else {
            yield put(actions.getSiteBySubPraticeIdFailure('No data found'));
        }
    } catch (error) {
        console.error('Facility by SubPractice Fetch Error:', error);
        yield put(actions.getSiteBySubPraticeIdFailure('Failed to fetch Facilities'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load Facilities' });
    }
}
//------------------Rad Hourly Volume Share - end------------------//


export default function* radHourlyVolumeShareSaga() {
    // Rad Hourly Volume Share - start
    yield takeEvery(types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST, fetchRadHourlyVolumeShareUnReadDetailsSaga);
    yield takeEvery(types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST, fetchRadHourlyVolumeShareReadDetailsSaga);
    yield takeEvery(types.EXPORT_RAD_HOURLY_VOLUME_SHARE_REQUEST, exportRadHourlyVolumeShareSaga);
    yield takeEvery(types.GET_DORPDOWN_RAD_SITES_REQUEST, getDropdownRadSitesSaga);
    yield takeEvery(types.GET_WORKLIST_BY_RPCE_ID_REQUEST, getWorklistRpceIDSaga);
    yield takeEvery(types.GET_PRATICES_BY_WORKLIST_ID_REQUEST, getPracticeByWorklistIDSaga);
    yield takeEvery(types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST, getSubPracticeByPracticeIDSaga);
    yield takeEvery(types.GET_SITE_BY_SUB_PRATICE_ID_REQUEST, getSiteBySubPraticeIDSaga);
    // Rad Hourly Volume Share - end
}